const isMigrateFromElexys = () => {
  return process.env.VUE_APP_MIGRATE_FROM_ELEXYS === "true";
};
export default isMigrateFromElexys;
